export const REGISTERED_PATHS = new Set([
  "/",
  "/kesfet",
  "/arama",
  "/etkinlik-olustur",
  "/etkinlik-detay",
  "/harita",
  "/squadlar",
  "/bildirimler",
  "/profilim",
  "/kullanici-profili",
  "/profili-duzenle",
  "/skilltree",
  "/skilltree2",
  "/skilltree3",
  "/skilltree4",
  "/ayarlar",
  "/ayar-detay",
  "/telefon-dogrulama",
  "/email-dogrulama",
  "/eposta-dogrulama",
  "/host",
  "/admin-ajanda",
  "/hakkimizda",
  "/topluluk-ilkeleri",
  "/moderatorluk",
  "/partnerlik",
  "/sosyal-medya",
  "/yasal",
  "/privacy",
  "/policy",
  "/gizlilik-politikasi",
  "/terms",
  "/kullanim-kosullari",
  "/giris",
  "/kayit",
  "/kayit-ol",
  "/sifremi-unuttum",
]);

export const PUBLIC_PATHS = new Set(["/giris", "/kayit", "/kayit-ol", "/sifremi-unuttum", "/skilltree", "/skilltree2", "/skilltree3", "/skilltree4"]);

const AUTH_ENTRY_PATHS = new Set(["/giris", "/kayit", "/kayit-ol"]);
const RESERVED_ALIAS_SEGMENTS = new Set([
  "__",
  "api",
  "assets",
  "auth-action.html",
  "brand",
  "data",
  "favicon.ico",
  "mylove",
  "mylove2",
  "robots.txt",
  "skilltree",
  "skilltree3",
  "user-cards",
]);

export function normalizeProfileAlias(value) {
  return String(value || "").trim().replace(/^@+/, "").toLocaleLowerCase("tr-TR");
}

export function isAliasProfilePath(pathname) {
  const path = String(pathname || "");
  if (!path.startsWith("/") || path === "/" || REGISTERED_PATHS.has(path)) return false;
  const segment = normalizeProfileAlias(decodeURIComponent(path.slice(1)));
  if (!segment || segment.includes("/") || RESERVED_ALIAS_SEGMENTS.has(segment)) return false;
  return /^[a-z0-9][a-z0-9._-]{2,31}$/i.test(segment);
}

function getOrigin() {
  if (typeof window !== "undefined") return window.location.origin;
  return "https://denkup.com";
}

export function sanitizeReturnPath(candidate, fallback = "/") {
  if (!candidate || typeof candidate !== "string") return fallback;

  try {
    const parsed = new URL(candidate, getOrigin());
    if (parsed.origin !== getOrigin()) return fallback;
    if ((!REGISTERED_PATHS.has(parsed.pathname) && !isAliasProfilePath(parsed.pathname)) || AUTH_ENTRY_PATHS.has(parsed.pathname)) return fallback;
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return fallback;
  }
}

export function getReturnPathFromSearch(search, fallback = "/") {
  const params = new URLSearchParams(search || "");
  return sanitizeReturnPath(params.get("return"), fallback);
}

export function appendReturnPath(path, returnPath) {
  const safeReturnPath = sanitizeReturnPath(returnPath);
  if (safeReturnPath === "/") return path;
  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}return=${encodeURIComponent(safeReturnPath)}`;
}

export function buildLoginRedirect({ pathname, search = "", hash = "" }) {
  const requestedPath = `${pathname || "/"}${search}${hash}`;
  if (!REGISTERED_PATHS.has(pathname) && !isAliasProfilePath(pathname)) return "/giris";
  return appendReturnPath("/giris", requestedPath);
}
